import { Row } from "antd";
import "../../styles/upload-error.scss";

type ErrorListProps = {
  errors: string[];
};

export const ErrorList = ({ errors }: ErrorListProps) => {
  return (
    <Row className="upload-errors">
      <p className="my-0">
        Some dynamic fields specified in the template do not match the scheme
        names or entities hierarchy:
      </p>
      <ul className="pl-5 mt-2">
        {errors.map((error: string, i: number) => (
          <li key={i} title={error}>
            <p className="elipsis my-0">{error}</p>
          </li>
        ))}
      </ul>
    </Row>
  );
};
